import React, { useState, useEffect } from "react";
import styles from "./CheckoutPages.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  calculateToDatePlus,
  currentDateSingle,
  formatIndianCurrency,
  getDateByMonth,
} from "../../../utils/utils";
import { showErrorToast } from "../../../assets/toastUtils";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import AddressAutocomplete from "../../CustomGooglePlaceAPi/AddressAutocomplete";
import {
  SvgAccordion,
  SvgClock,
  SvgLocation,
  SvgNext,
} from "../../../utils/svgIcons";
import ItnerarySideBar from "../../ItnerarySideBar/ItnerarySideBar";
import CheckoutFooter from "../NewFooterUI/CheckoutFooter";
import NTTData from "../../PaymentGateway/NTTData";
import imgNotFound from "../../../assets/images/single-image.png";
import AgentSideBar from "../../../Pages/Agent/AgentSideBar/AgentSideBar";
import AgentHeader from "../../../Pages/Agent/AgentHeader/AgentHeader";
import NewItnerarySidebar from "../../ItnerarySideBar/NewItnerarySidebar";
import PayLater from "../../PayLater/PayLater";

const PackagesCheckoutPage = () => {
  // All Hooks
  const navigate = useNavigate();
  const location = useLocation();
  const { packageHandle } = useParams();
  const userType = localStorage.getItem("userType");

  // All Hooks End

  // All States
  const [packageData, setPackageData] = React.useState({});
  const [addressData, setAddressData] = React.useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  // Aside States
  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const [showPriceBreakUp, setShowPriceBreakUp] = useState(true);

  const [showPriceDetails, setShowPriceDetails] = useState(true);

  const [isItineraryDetailsVisible, setIsItineraryDetailsVisible] =
    useState(false);
  const [bookingData, setBookingData] = useState({});
  const [guestDetails, setGuestDetails] = useState(true);
  const [businessProfile, setBusinessProfile] = useState(false);
  const [customizableRatesLoader, setCustomizableRatesLoader] = useState(false);
  // const [guestDetailsArray, setGuestDetailsArray] = useState([]);
  const [formData, setFormData] = useState({
    customer_name: "",
    customer_phone: "",
    customer_email: "",
    customer_zipcode: "",
  });

  const [bookingValues, setBookingValues] = useState({
    taxSlab: 0,
    subtotal: 0,
    taxAmount: 0,
    grandTotal: 0,
    discountAmt: 0,
    totalChildAdultCost: 0,
  });
  const [startPayment, setStartPayment] = useState(false);
  const [addGuestDetailsAdd, setAddGuestDetailsAdd] = useState(true);

  // All States End

  // All Api Calls
  const getPackageDetails = async (packageHandle) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch/single/${packageHandle}`,
        requestOptions
      );
      const data = await response.json();
      setPackageData(data?.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  // All Api Calls End

  // All Functions
  React.useState(() => {
    getPackageDetails(packageHandle);
  }, []);
  const handleAddressData = (data) => {
    setAddressData(data);
  };
  // All Functions End

  // Aside
  const [mobilePriceBreakup, setMobilePriceBreakup] = useState(false);
  const [priceBreakupPopup, setPriceBreakupPopup] = useState(false);

  const {
    packageData: singlePackageData,
    // bookingData,
    selectedCategory,
    calculationsOfPackages,
    hotelDayByDay,
    vehicleDetails,
    customized,
    ratesOfPackages,
    selectedAddOns,
    markupData,
    selectedMealPlan,
    allPackageHotels,
    commission,
    // roomsDetails,
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    selectedAutomaticDiscount,
    selectedDiscount,
  } = location?.state || {};

  // console.log(
  //   "asdasd",
  //   // packageData,
  //   // bookingData,
  //   // selectedCategory,
  //   // calculationsOfPackages,
  //   // hotelDayByDay,
  //   // vehicleDetails,
  //   // customized,
  //   // ratesOfPackages,
  //   // selectedAddOns,
  //   // markupData,
  //   selectedMealPlan,
  //   allPackageHotels,
  //   // commission,
  //   // roomsDetails,
  //   totalAddonsCost,
  //   totalAddonsCostWithoutCommission,
  //   selectedAutomaticDiscount,
  //   selectedDiscount
  // );

  useEffect(() => {
    const updateHideToggle = () => {
      if (window.innerWidth <= 768) {
        setMobilePriceBreakup(true);
      } else {
        setMobilePriceBreakup(false);
      }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  // const handleAddressData = (data) => {
  //   setAddressData(data);
  // };

  const toggleBusinessProfile = () => {
    setBusinessProfile(!businessProfile);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }
    const data = {
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      radio: params.get("radio"),
      childAge: childAges,
      packageId: params.get("packageId"),
      packagehandle: params.get("packagehandle"),

      departureDay: params.get("checkinDay"),
      departureMonth: params.get("checkinMonth"),
      departureYear: params.get("checkinYear"),
      // tourDate : params.get("checkinYear")-params.get("checkinMonth")-params.get("checkinDay")
    };
    const checkInDate = `${data.departureYear}-${String(
      data.departureMonth
    ).padStart(2, "0")}-${String(data.departureDay).padStart(2, "0")}`;

    // setGuest(data.guest);
    // setChildren(data.children);
    // setRooms(data.room);
    // setChildAge(childAges);

    if (data.checkinYear && data.checkinMonth && data.checkinDay) {
      setBookingData({ ...data, tourDate: checkInDate });
    } else {
      setBookingData({ ...data, tourDate: currentDateSingle });
    }

    // setStartDate(checkInDate);
    // setEndDate(checkOutDate);
    // setBookingData({...data, tourDate: checkInDate});
  }, [location.search]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCloseSlider = () => {
    setIsSliderVisible(false);
  };

  const handleChangeClick = async () => {
    setIsSliderVisible(true);
  };

  const toggleGuestDetails = () => {
    setGuestDetails(!guestDetails);
  };

  const [atomAccessToken, setAtomAccessToken] = useState(null);
  const [packageBookingData, setPackageBookingData] = useState(null);

  // const sendDataToParent = (data, type) => {
  //   setGuestDetailsArray(data);
  //   setAddGuestDetailsAdd(type);
  // };

  const under6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) < 6
  );

  const over6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) >= 6
  );

  // payment Gateway
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState(null);
  const [paymentGatewayLoader, setPaymentGatewayLoader] = useState(false);

  const fetchPaymentGateway = async () => {
    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        key: process.env.REACT_APP_BASE_API_KEY,
      };
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/fetch/active`,
        {
          method: "GET",
          headers: headers,
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setPaymentGateways(result.data);

      const firstActiveGateway = result.data.find(
        (gateway) => gateway.gatewayName === "NTTData"
      );
      if (firstActiveGateway) {
        setSelectedPaymentGateway(firstActiveGateway);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePaymentGatewayChange = (item) => {
    setSelectedPaymentGateway(item);
  };

  useEffect(() => {
    fetchPaymentGateway();
  }, []);

  const guestDataHandleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const [allTravellerDetailsAdd, setAllTravellerDetailsAdd] = useState(false);
  const [travellers, setTravellers] = useState(2);
  const [isTravellerDetailsPopup, setIsTravellerDetailPopup] = useState(false);
  const [selectedTraveller, setSelectedTraveller] = useState({
    index: 1,
    // traveller: null,
  });
  const [travellerDetails, setTravellerDetails] = useState(
    Array(travellers).fill({
      guest_name: "",
      guest_email: "",
      guest_phone: "",
      isPrimary: false,
      guest_address: "",
      guest_country: "",
      guest_city: "",
      guest_state: "",
      zipcode: "",
    })
  );

  const handleTravellerClick = (e, traveller, index) => {
    e.stopPropagation();
    setSelectedTraveller({
      index: index,
      traveller: traveller,
    });
    setIsTravellerDetailPopup(true);
  };

  const handlePrimaryChange = (e, index) => {
    e.stopPropagation();
    setTravellerDetails((prevDetails) => {
      const newDetails = prevDetails.map((traveller, i) => ({
        ...traveller,
        isPrimary: i === index,
      }));
      return newDetails;
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // setTravellerDetails((prevDetails) => {
    //   const newDetails = [...prevDetails];
    //   newDetails[selectedTraveller.index] = {
    //     ...newDetails[selectedTraveller.index],
    //     [name]: value,
    //   };
    //   return newDetails;
    // });

    setTravellerDetails((prevDetails) => {
      const newDetails = prevDetails.map((traveller, i) =>
        i === selectedTraveller.index
          ? { ...traveller, [name]: value }
          : traveller
      );

      setSelectedTraveller((prevSelected) => ({
        ...prevSelected,
        traveller: newDetails[selectedTraveller.index],
      }));

      return newDetails;
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }
    const data = {
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      radio: params.get("radio"),
      childAge: childAges,
      packageId: params.get("packageId"),
      packagehandle: params.get("packagehandle"),
      // tourDate : params.get("checkinYear")-params.get("checkinMonth")-params.get("checkinDay")
    };

    setTravellers(data.guest ? data.guest : 2);

    const guestArray = Array(Number(data.guest)).fill({
      guest_name: "",
      guest_email: "",
      guest_phone: "",
      isPrimary: false,
      pax_type: "adult",
      index: i,
    });

    // const childArray = Array(Number(childAges.length)).fill({
    //   name: "",
    //   type:"children",
    //   age:"",
    // });

    const childArray = childAges?.map((child, index) => ({
      name: "",
      pax_type: "children",
      age: child,
      index: index + 1,
    }));

    setTravellerDetails([...guestArray, ...childArray]);

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    // setGuest(data.guest);
    // setChildren(data.children);
    // setRooms(data.room);
    // setChildAge(childAges);

    if (data.checkinYear && data.checkinMonth && data.checkinDay) {
      setBookingData({ ...data, tourDate: checkInDate });
    } else {
      setBookingData({ ...data, tourDate: currentDateSingle });
    }

    // setStartDate(checkInDate);
    // setEndDate(checkOutDate);
    // setBookingData({...data, tourDate: checkInDate});
  }, [location.search]);

  function getAdvancePercentage(currentDate, selectedDate) {
    function getMinusDays(currentDate, selectedDate) {
      if (!currentDate || !selectedDate) return null;

      const current = new Date(currentDate);

      const selected = new Date(selectedDate);

      if (isNaN(current.getTime()) || isNaN(selected.getTime())) return null;

      current.setHours(0, 0, 0, 0);

      selected.setHours(0, 0, 0, 0);

      const diffTime = selected - current;

      return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    }

    const days = getMinusDays(currentDate, selectedDate);

    if (days === null || days < 0) return null; // Invalid or past date

    if (days >= 45 || (days >= 30 && days <= 44)) {
      return 25;
    } else if (days >= 15 && days <= 29) {
      return 50;
    }
    //  else if (days >= 7 && days <= 14) {
    //   return 75;
    // }
     else if (days < 7) {
      return null;
    }

    return null; // fallback
  }

  const [payNow, setPayNow] = useState(null);
  const [payLater, setPayLater] = useState(null);

  const [selectedPercent, setSelectedPercent] = useState(null);

  const handlePaymentSelection = ({ selectedPercent, payNow, payLater }) => {
    setPayNow(payNow);
    setPayLater(payLater);
    setSelectedPercent(selectedPercent);
    //  console.log({ selectedPercent, payNow, payLater }, "selectedPercent");
  };

  const bookPackageHandle = async () => {
    setPaymentGatewayLoader(true);
    const formattedDestination = packageData?.packageDestination?.map(
      (destination) => ({
        id: destination.destinationId,
      })
    );

    let childrenLessThanSix = 0;
    let childrenGreaterThanSix = 0;

    if (bookingData.children && parseInt(bookingData.children) > 0) {
      childrenLessThanSix = bookingData.childAge.filter(
        (age) => parseInt(age) < 6
      )?.length;
      childrenGreaterThanSix = bookingData.childAge.filter(
        (age) => parseInt(age) > 6
      )?.length;
    }

    const transformedData = packageData?.packageItinerary?.map(
      (item, index) => ({
        day: item?.day,
        start_destination: item?.startDestination,
        end_destination: item.endDestination,
        pickup: item.pickup,
        drop: item.drop,
        heading_information: item?.additionalDetails?.heading,
        description_information: item.additionalDetails?.long_description,
        accommodations: item.accommodation.map((acc) => {
          return {
            accommodation_id: acc.accommodationId,
            name: acc.name,
            destination: acc.city,
            hotel_category: acc.hotelcategory,
            star_rating: acc.starRating,
            featured_image: acc.featuredImage,
            supplier_id: acc.supplierId ? acc.supplierId : "",
            room_id: acc?.roomDetails[0]?.roomId
              ? acc?.roomDetails[0]?.roomId
              : "",
            room_type: acc?.roomDetails[0]?.name
              ? acc?.roomDetails[0]?.name
              : "As per package",
            // room_cost: acc.room_cost ? acc.room_cost : 500.00,
            meal_plan: ratesOfPackages.MealPlan
              ? ratesOfPackages.MealPlan
              : "ep",
            rooms: acc.rooms ? acc.rooms : "1",
            nights: acc.nights ? acc.nights : 1,
            adults: bookingData.guest,
            extra_adult: ratesOfPackages.ExtraAdultCount
              ? ratesOfPackages.ExtraAdultCount
              : 0,
            child_w_bed: childrenLessThanSix,
            child_wo_bed: childrenGreaterThanSix,
            extra_adult_cost: ratesOfPackages.ExtraAdult
              ? ratesOfPackages.ExtraAdult
              : 0,
            child_w_bed_cost: ratesOfPackages.ChildWithBedCost
              ? ratesOfPackages.ChildWithBedCost
              : 0,
            child_wo_bed_cost: ratesOfPackages.ChildWithOutBedCost
              ? ratesOfPackages.ChildWithOutBedCost
              : 0,
            adhoc: false,
            check_in: calculateToDatePlus(bookingData?.tourDate, index),
            check_out: calculateToDatePlus(bookingData?.tourDate, index + 1),
          };
        }),
        activities: item.activity.map((act, actIndex) => {
          const ratesArray = act?.rates;
          let accPrice = ratesArray?.find(
            (rate) => Number(rate?.pax) === Number(bookingData?.guest)
          )?.amount;

          if (!accPrice && ratesArray?.length > 0) {
            accPrice = ratesArray[0]?.amount;
          }

          return {
            activity_id: act.activityId,
            name: act.name,
            featured_image: act.featuredImage,
            supplier_id: act?.vendorId,
            destination: act.destinationName,
            validity: calculateToDatePlus(bookingData?.tourDate, actIndex),
            time: "10:00 AM",
            pax: bookingData?.guest,
            price: accPrice,
            adhoc: false,
          };
        }),
      })
    );

    const automaticDiscountToSend = (selectedAutomaticDiscount || []).map(
      (item) => ({
        rate: item?.promotionMode || "",
        amount: item?.promotionAmount || 0,
      })
    );

    const selectedDiscountToSend = (selectedDiscount || []).map((item) => ({
      rate: item?.promotionMode || "",
      amount: item?.promotionAmount || 0,
    }));

    try {
      const myHeaders = {
        Accept: "application/json",
        "Content-Type": "application/json",
        key: process.env.REACT_APP_BASE_API_KEY,
        Cookie: process.env.REACT_APP_COOKIE,
      };

      const primaryTraveler = travellerDetails?.find(
        (traveler) =>
          traveler.isPrimary &&
          traveler.guest_name?.trim() &&
          traveler.guest_email?.trim() &&
          traveler.guest_phone?.trim()
      );

      const fallbackTraveler = travellerDetails?.find(
        (traveler) =>
          traveler.guest_name?.trim() &&
          traveler.guest_email?.trim() &&
          traveler.guest_phone?.trim()
      );
      const selectedTraveler = primaryTraveler || fallbackTraveler || null;

      const raw = JSON.stringify({
        name: packageData?.packageName,
        booking_type: "package",
        customer_type: userType === "agent" ? "agent" : "customer",
        customer_name: selectedTraveler?.guest_name?.trim()
          ? selectedTraveler.guest_name
          : formData.customer_name,
        customer_email: selectedTraveler?.guest_email?.trim()
          ? selectedTraveler.guest_email
          : formData.customer_email,
        customer_phone: selectedTraveler?.guest_phone?.trim()
          ? selectedTraveler.guest_phone
          : formData.customer_phone,
        customer_address: addressData.address,
        customer_country: addressData.country,
        customer_state: addressData.state,
        customer_city: addressData.city,
        customer_zipcode: formData.customer_zipcode,
        start_date: bookingData?.tourDate,
        end_date: calculateToDatePlus(
          bookingData?.tourDate,
          packageData?.totalDays
        ),
        pickup_point: "City Center",
        drop_point: "Airport",
        nights: Number(packageData?.totalNights),
        days: Number(packageData?.totalDays),
        adults: Number(bookingData?.guest),
        children: Number(bookingData?.children),
        total: calculationsOfPackages?.basePrice,
        grand_total: calculationsOfPackages?.totalAmount,
        status: "hold",
        accommodation_notes_information: "",
        activity_notes_information: "",
        transport_notes_information: "",
        misc_details: [],
        tax_details: [
          {
            rate: 5,
            amount: calculationsOfPackages?.taxAmount,
          },
        ],
        discount_details_information: [
          ...(automaticDiscountToSend || []),
          ...(selectedDiscountToSend || []),
        ],
        markup_details: [
          {
            type: markupData?.markupType,
            rate: 0,
            amount: markupData?.amount,
          },
        ],
        itineraries: transformedData,
        addons: selectedAddOns?.map((addon) => ({
          account_addon_id: addon.addonId,
          name: addon.detail,
          price: addon.finalAddonPrice ? addon.finalAddonPrice : addon.price,
        })),
        transports: [],
        destinations: formattedDestination,
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/booking/create`,
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        }
      );

      const result = await response.json();
      if (result.success) {
        setPackageBookingData(result.data);
        // processPayment(result.data);
        setStartPayment(true);
        // setPaymentGatewayLoader(false);
      } else {
        showErrorToast(result.message);
        setPaymentGatewayLoader(false);
      }
    } catch (error) {
      console.error("Error creating package booking:", error);
    }
  };

  // NTT Data
  const mainData = [
    {
      apiStartValue: startPayment,
      selectedPaymentGateway: selectedPaymentGateway?.gatewayName,

      order_amount: payNow ? Number(payNow) : packageBookingData?.grandTotal,
      order_number: packageBookingData?.bookingNo,
      order_id: packageBookingData?.id,
      email: packageBookingData?.customerDetails?.email,
      phone: packageBookingData?.customerDetails?.phone,
      callbackUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${packageBookingData?.id}`,
      custEmail: packageBookingData?.customerDetails?.email,
      custMobile: packageBookingData?.customerDetails?.phone,
      returnUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${packageBookingData?.id}`,
    },
  ];

  return (
    <>
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />
        <div className="agent-info-container">
          <AgentHeader showSelectProperty={true} vendorProperty={false} />

          <section className={styles.checkout_section}>
            <div>
              <div className={styles.checkout_wrapper}>
                {/* Left Side */}
                <div className={styles.checkout_left}>
                  {/* Travelers Details */}
                  <div className={styles.white_wrapper}>
                    <div>
                      <div
                        className={`${styles.top_traveller_details} flex justify_content_between`}
                      >
                        <h6>Traveler Details</h6>{" "}
                        <div className="flex align_items_center flex_gap_5 cursor_pointer">
                          {" "}
                          <input
                            id="oneTravelers"
                            className="cursor_pointer"
                            type="checkbox"
                            checked={allTravellerDetailsAdd}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setIsTravellerDetailPopup(isChecked);
                              setAllTravellerDetailsAdd(isChecked);

                              const guestArray = Array(
                                Number(bookingData.guest)
                              ).fill({
                                guest_name: "",
                                guest_email: "",
                                guest_phone: "",
                                isPrimary: false,
                                pax_type: "adult",
                              });

                              const childArray = bookingData?.childAge?.map(
                                (child, index) => ({
                                  name: "",
                                  pax_type: "children",
                                  age: child,
                                  index: index + 1,
                                })
                              );

                              if (!isChecked) {
                                setTravellerDetails([
                                  ...guestArray,
                                  ...childArray,
                                ]);
                              }
                            }}
                          />
                          <label
                            htmlFor="oneTravelers"
                            className={`${styles.traveller_detail_label} cursor_pointer"`}
                            style={{ color: "#333" }}
                          >
                            {" "}
                            Enter All Traveler Details
                          </label>
                        </div>
                      </div>

                      {allTravellerDetailsAdd ? (
                        <>
                          {isTravellerDetailsPopup && (
                            <>
                              <div className="traveller_adult_main">
                                <h4>
                                  Traveler {Number(selectedTraveller.index) + 1}{" "}
                                  <sub>
                                    /
                                    {Number(travellers) +
                                      Number(bookingData?.children)}
                                  </sub>
                                </h4>
                                <div className="flex flex_gap_10 mb-2 flex_wrap">
                                  {travellerDetails.map((traveller, index) => {
                                    let adultCount = 1;
                                    let childrenCount = 1;

                                    if (traveller.pax_type === "adult") {
                                      adultCount++;
                                    } else if (
                                      traveller.pax_type === "children"
                                    ) {
                                      childrenCount++;
                                    }

                                    return (
                                      <div
                                        key={index}
                                        className={`traveller_adult_card ${
                                          selectedTraveller.index === index
                                            ? "selected"
                                            : ""
                                        }`}
                                        onClick={(e) =>
                                          handleTravellerClick(
                                            e,
                                            traveller,
                                            index
                                          )
                                        }
                                      >
                                        {" "}
                                        {travellerDetails[index]?.pax_type ===
                                          "adult" && (
                                          <div>
                                            <input
                                              type="radio"
                                              className="primary_checkbox"
                                              checked={
                                                travellerDetails[index]
                                                  ?.isPrimary
                                              }
                                              onChange={(e) =>
                                                handlePrimaryChange(e, index)
                                              }
                                            />
                                          </div>
                                        )}
                                        <span className="text-capitalize">
                                          {traveller.pax_type}{" "}
                                          {traveller.pax_type === "adult"
                                            ? index + 1
                                            : traveller.index}
                                        </span>
                                        {travellerDetails[index]?.pax_type ===
                                        "adult" ? (
                                          travellerDetails[
                                            index
                                          ]?.guest_name?.trim() !== "" &&
                                          travellerDetails[
                                            index
                                          ]?.guest_email?.trim() !== "" &&
                                          travellerDetails[
                                            index
                                          ]?.guest_phone?.trim() !== "" ? (
                                            <div className="traveller_adult_card_tick">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                height="15px"
                                                viewBox="0 -960 960 960"
                                                width="15px"
                                                fill="#25d366"
                                              >
                                                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                              </svg>
                                            </div>
                                          ) : null
                                        ) : travellerDetails[index]
                                            ?.pax_type === "children" ? (
                                          travellerDetails[
                                            index
                                          ]?.name?.trim() !== "" &&
                                          travellerDetails[
                                            index
                                          ]?.age?.trim() !== "" ? (
                                            <div className="traveller_adult_card_tick">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                height="15px"
                                                viewBox="0 -960 960 960"
                                                width="15px"
                                                fill="#25d366"
                                              >
                                                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                              </svg>
                                            </div>
                                          ) : null
                                        ) : null}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              <div className="traveller_adult_form_details">
                                {selectedTraveller?.traveller?.pax_type ===
                                  "adult" && (
                                  <>
                                    <form className="form_flex_traveler">
                                      <div>
                                        {" "}
                                        <label htmlFor="">Full Name</label>
                                        <input
                                          type="text"
                                          placeholder="Enter full name"
                                          name="guest_name"
                                          value={
                                            travellerDetails[
                                              selectedTraveller.index
                                            ]?.guest_name
                                          }
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      <div>
                                        {" "}
                                        <label htmlFor="">Email Address</label>
                                        <input
                                          type="email"
                                          placeholder="Enter email address"
                                          name="guest_email"
                                          value={
                                            travellerDetails[
                                              selectedTraveller.index
                                            ]?.guest_email
                                          }
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      <div>
                                        {" "}
                                        <label htmlFor="">Phone</label>
                                        <input
                                          type="number"
                                          placeholder="Enter phone number"
                                          name="guest_phone"
                                          value={
                                            travellerDetails[
                                              selectedTraveller.index
                                            ]?.guest_phone
                                          }
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </form>
                                  </>
                                )}

                                {selectedTraveller?.traveller?.pax_type ===
                                  "children" && (
                                  <form className="form_flex_traveler">
                                    <input
                                      type="text"
                                      placeholder="Name"
                                      name="name"
                                      value={
                                        travellerDetails[
                                          selectedTraveller.index
                                        ]?.name
                                      }
                                      onChange={handleInputChange}
                                    />
                                    <input
                                      //  type="number"
                                      placeholder="Age"
                                      name="age"
                                      disabled
                                      value={`Age = ${
                                        travellerDetails[
                                          selectedTraveller.index
                                        ]?.age
                                      }`}
                                      onChange={handleInputChange}
                                    />
                                  </form>
                                )}

                                <button
                                  className="save_btn"
                                  onClick={() =>
                                    setIsTravellerDetailPopup(false)
                                  }
                                >
                                  Save
                                </button>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="mt-10">
                          <div className={styles.input_wrapper}>
                            <label htmlFor="full_name">Full Name</label>
                            <input
                              id="full_name"
                              type="text"
                              name="customer_name"
                              onChange={guestDataHandleChange}
                              value={formData.customer_name}
                            />
                          </div>
                          <div className="flex justify_content_between mt-10 flex_gap_10">
                            <div className={`${styles.input_wrapper} w-half`}>
                              <label htmlFor="email">Email</label>
                              <input
                                id="email"
                                type="email"
                                name="customer_email"
                                value={formData.customer_email}
                                onChange={guestDataHandleChange}
                              />
                            </div>
                            <div className={`${styles.input_wrapper} w-half`}>
                              <label
                                id="phone"
                                type="phone"
                                htmlFor="full_name"
                              >
                                Phone
                              </label>
                              <input
                                id="phone"
                                type="number"
                                name="customer_phone"
                                value={formData.customer_phone}
                                onChange={guestDataHandleChange}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {allTravellerDetailsAdd && (
                      <div className="no_of_travellers">
                        <div>
                          <div className="overflow_x_scroll_y_hidden">
                            {travellerDetails?.length > 0 &&
                              travellerDetails.every(
                                (item) =>
                                  item.guest_name !== "" &&
                                  item.guest_phone !== "" &&
                                  item.guest_phone !== ""
                              ) && (
                                <table className="rates_table">
                                  {" "}
                                  <tr>
                                    <th className="">Name</th>
                                    <th className="text-center">Type</th>
                                    <th className="text-center">Email</th>
                                    <th className="text-center">Phone no.</th>
                                    <th></th>
                                  </tr>{" "}
                                  {travellerDetails.map((item, index) => {
                                    const allFeildExists =
                                      item?.guest_name !== "" &&
                                      item.guest_phone !== "" &&
                                      item?.guest_phone
                                        ? true
                                        : false;
                                    return (
                                      <>
                                        <tr>
                                          <td className="p-5">
                                            {item?.guest_name}{" "}
                                            {item?.pax_type === "children" && (
                                              <span style={{ border: "0" }}>
                                                {" "}
                                                {/* ( Age: {item?.age}){" "} */}
                                                {item?.name}
                                              </span>
                                            )}
                                          </td>
                                          <td className="p-5 text-center text-capitalize">
                                            {item?.pax_type}
                                          </td>
                                          <td className="p-5 text-center">
                                            {item?.guest_email
                                              ? item?.guest_email
                                              : "-"}
                                          </td>
                                          <td className="p-5 text-center">
                                            {item?.guest_phone
                                              ? item.guest_phone
                                              : "-"}
                                          </td>
                                          <td>
                                            <svg
                                              onClick={(e) => [
                                                handleTravellerClick(
                                                  e,
                                                  {
                                                    pax_type: "adult",
                                                    guest_name: "",
                                                    guest_email: "",
                                                    guest_phone: "",
                                                  },
                                                  0
                                                ),
                                                setSelectedTraveller({
                                                  index: index,
                                                  traveller: item,
                                                }),
                                              ]}
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <mask
                                                id="mask0_2810_13923"
                                                style={{ maskType: "alpha" }}
                                                maskUnits="userSpaceOnUse"
                                                x="0"
                                                y="0"
                                                width="20"
                                                height="20"
                                              >
                                                <rect
                                                  width="20"
                                                  height="20"
                                                  fill="#D9D9D9"
                                                />
                                              </mask>
                                              <g mask="url(#mask0_2810_13923)">
                                                <path
                                                  d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                                                  fill="#333333"
                                                />
                                              </g>
                                            </svg>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                                </table>
                              )}
                          </div>
                        </div>
                      </div>
                    )}
                    {/* {!(allTravellerDetailsAdd &&
                  travellerDetails?.length > 0 &&
                  travellerDetails.every(
                    (item) =>
                      item.guest_name !== "" &&
                      item.guest_phone !== "" &&
                      item.guest_phone !== ""
                  )) && (
                    <div className="mt-10">
                      <div className={styles.input_wrapper}>
                        <label htmlFor="full_name">Full Name</label>
                        <input
                          id="full_name"
                          type="text"
                          name="customer_name"
                          onChange={guestDataHandleChange}
                          value={formData.customer_name}
                        />
                      </div>

                      <div className="flex justify_content_between mt-10 flex_gap_10">
                        <div className={`${styles.input_wrapper} w-half`}>
                          <label htmlFor="email">Email</label>
                          <input
                            id="email"
                            type="email"
                            name="customer_email"
                            value={formData.customer_email}
                            onChange={guestDataHandleChange}
                          />
                        </div>
                        <div className={`${styles.input_wrapper} w-half`}>
                          <label id="phone" type="phone" htmlFor="full_name">
                            Phone
                          </label>
                          <input
                            id="phone"
                            type="number"
                            name="customer_phone"
                            value={formData.customer_phone}
                            onChange={guestDataHandleChange}
                          />
                        </div>
                      </div>
                    </div>
                  )} */}
                  </div>

                  {/* Traveler Address */}
                  <div className={`${styles.white_wrapper} mt-15`}>
                    <h6>Traveler Address</h6>

                    <div className="mt-10">
                      <div className={styles.input_wrapper}>
                        <label htmlFor="address">Search Your Address</label>
                        <AddressAutocomplete
                          formdata={addressData}
                          onAddressChange={handleAddressData}
                        />
                      </div>

                      <div className={`${styles.input_wrapper} mt-10`}>
                        <label htmlFor="zipcode">Zipcode</label>
                        <input
                          id="zipcode"
                          type="number"
                          name="customer_zipcode"
                          value={formData.customer_zipcode}
                          onChange={guestDataHandleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Package Details */}
                  <div className={`${styles.white_wrapper} mt-15`}>
                    <div
                      className="flex justify_content_between align_items_center pointer"
                      onClick={() => setShowPriceDetails(!showPriceDetails)}
                    >
                      <h6>Package Details</h6>
                      <span
                        style={{
                          transform: showPriceDetails
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                        }}
                      >
                        <SvgAccordion />
                      </span>
                    </div>
                    {showPriceDetails && (
                      <div
                        className="accordion-content"
                        style={{
                          maxHeight: showPriceDetails ? "500px" : "0px",
                          overflow: "hidden",
                          transition: "max-height 0.4s ease-in-out",
                        }}
                      >
                        <div
                          className={`${styles.package_details_heading} mt-10`}
                        >
                          <div className={styles.package_details_image}>
                            {packageData?.packageImages?.length > 0 ? (
                              <img src={packageData?.packageImages[0]} alt="" />
                            ) : (
                              <img src={imgNotFound} alt="" />
                            )}
                          </div>

                          <div className={styles.package_details_about}>
                            <div
                              className={`${styles.package_details_night_location} flex flex_gap_10`}
                            >
                              <div className={`${styles.days_and_night} flex`}>
                                <span className="flex align_items_center">
                                  <SvgClock />
                                </span>
                                <span>
                                  {packageData?.totalDays}D /{" "}
                                  {packageData?.totalNights}N
                                </span>
                              </div>
                              <div
                                className={`${styles.starting_location} font_12 flex align_items_center`}
                              >
                                <span className="flex align_items_center">
                                  <SvgLocation />
                                </span>
                                {packageData?.packageHub}
                              </div>
                            </div>

                            <h6 className="mt-10">
                              {packageData?.packageName}
                            </h6>
                          </div>
                        </div>

                        <div className={`${styles.itinerary_details} mt-15`}>
                          <div className={styles.itinerary_details_card}>
                            <h3>Tour Date</h3>
                            <p>{getDateByMonth(bookingData?.tourDate)}</p>
                          </div>
                          <div className={styles.itinerary_details_card}>
                            <h3>Adults & children</h3>
                            <p>
                              {bookingData?.guest} Adults,{" "}
                              {bookingData?.children} Children
                            </p>
                          </div>
                          <div className={styles.itinerary_details_card}>
                            <h3>Category</h3>
                            <p>
                              {selectedCategory}{" "}
                              <span style={{ textTransform: "uppercase" }}>
                                ({selectedMealPlan})
                              </span>
                            </p>
                          </div>
                        </div>

                        <div
                          className={`flex align_items_center justify_content_end mt-15`}
                        >
                          <button
                            onClick={() => setIsItineraryDetailsVisible(true)}
                            className={`${styles.review_button}`}
                          >
                            Review Itinerary
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  {currentDateSingle != bookingData?.tourDate && (
                    <PayLater
                      totalAmt={calculationsOfPackages?.totalAmount}
                      fiftyPercentAmount={getAdvancePercentage(
                        currentDateSingle,
                        bookingData?.tourDate
                      )}
                      onSelectionChange={handlePaymentSelection}
                    />
                  )}

                  <button
                    onClick={bookPackageHandle}
                    className={styles.checkout_button}
                    disabled={paymentGatewayLoader}
                  >
                    Proceed to Payment
                    <span>
                      <SvgNext />
                    </span>
                  </button>
                </div>

                {/* Right Side */}
                <div className={styles.checkout_right}>
                  <aside
                    // id="Price-Break"
                    style={{
                      background: showPriceBreakUp ? "#E8F9F1" : "#FFFFFF",
                    }}
                  >
                    <div className="common_background common_background_parent_sticky m_0">
                      <div>
                        <div
                          className="flex justify_content_between pointer"
                          onClick={() => setShowPriceBreakUp(!showPriceBreakUp)}
                        >
                          <h4 style={{ fontSize: "16px" }}>Price Breakup</h4>
                          <button>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                              style={{
                                transition: "transform 0.3s",
                                transform: showPriceBreakUp
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                              }}
                            >
                              <mask
                                id="mask0_6802_2345"
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="18"
                                height="19"
                              >
                                <rect
                                  y="18.5"
                                  width="18"
                                  height="18"
                                  transform="rotate(-90 0 18.5)"
                                  fill="#D9D9D9"
                                />
                              </mask>
                              <g mask="url(#mask0_6802_2345)">
                                <path
                                  d="M8.99971 11.6113L14.6493 5.9617C14.7983 5.8127 14.9737 5.74008 15.1756 5.74383C15.3776 5.7477 15.5531 5.82414 15.7021 5.97314C15.8511 6.12227 15.9256 6.29777 15.9256 6.49964C15.9256 6.70152 15.8511 6.87702 15.7021 7.02614L9.96027 12.7794C9.82464 12.915 9.67271 13.0155 9.50446 13.0809C9.33621 13.1463 9.16796 13.179 8.99971 13.179C8.83146 13.179 8.66321 13.1463 8.49496 13.0809C8.32671 13.0155 8.17477 12.915 8.03914 12.7794L2.28571 7.02614C2.13671 6.87702 2.06414 6.69958 2.06802 6.49383C2.07189 6.28808 2.14833 6.1107 2.29733 5.9617C2.44633 5.8127 2.62183 5.7382 2.82383 5.7382C3.02571 5.7382 3.20114 5.8127 3.35014 5.9617L8.99971 11.6113Z"
                                  fill="#1C1B1F"
                                />
                              </g>
                            </svg>
                          </button>
                        </div>

                        {showPriceBreakUp && (
                          <div
                            style={{
                              borderTop: "0.5px solid #ccc",
                              marginTop: "10px",
                            }}
                          >
                            <div className="flex justify_content_between mt-10">
                              <p>
                                Adult Cost
                                <small>
                                  {" "}
                                  (
                                  {calculationsOfPackages?.onlyAdultCost /
                                    calculationsOfPackages?.adultNumber}{" "}
                                  X {calculationsOfPackages?.adultNumber})
                                </small>
                              </p>
                              <span
                                className={`room_text-right ${
                                  Number(
                                    calculationsOfPackages?.onlyAdultCost
                                  ) <= 0 && "filterBlur3"
                                }`}
                              >
                                {formatIndianCurrency(
                                  Number(calculationsOfPackages?.onlyAdultCost)
                                )}
                              </span>
                            </div>

                            {calculationsOfPackages?.extraAdultNumber > 0 && (
                              <div className="flex justify_content_between mt-10">
                                <p>
                                  Extra Adult Cost{" "}
                                  <small>
                                    {" "}
                                    (
                                    {calculationsOfPackages?.ExtraAdultCost /
                                      calculationsOfPackages?.extraAdultNumber}{" "}
                                    X {calculationsOfPackages?.extraAdultNumber}
                                    )
                                  </small>
                                </p>
                                <span
                                  className={`room_text-right ${
                                    Number(
                                      calculationsOfPackages?.totalAmount
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                >
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.ExtraAdultCost
                                  )}
                                  {/* {formatIndianCurrency(Number(calculationsOfPackages?.ExtraAdultCost) + Number(calculationsOfPackages?.basePrice))} */}
                                </span>
                              </div>
                            )}

                            {under6AgeChildren?.length > 0 &&
                            calculationsOfPackages?.childNumber > 0 &&
                            calculationsOfPackages?.childCostWithOutBed ? (
                              <div className="flex justify_content_between mt-10">
                                <p>
                                  Child Cost ({`< 6 yrs`}){" "}
                                  <small>
                                    ̀ (
                                    {Math.round(
                                      calculationsOfPackages?.childCostWithOutBed /
                                        under6AgeChildren?.length
                                    )}
                                    X {under6AgeChildren?.length})
                                  </small>
                                </p>
                                <span
                                  className={`room_text-right ${
                                    Number(
                                      calculationsOfPackages?.childCostWithOutBed
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                >
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.childCostWithOutBed
                                  )}
                                </span>
                              </div>
                            ) : null}

                            {over6AgeChildren?.length > 0 &&
                            calculationsOfPackages?.childNumber > 0 &&
                            calculationsOfPackages?.childCostWithBed ? (
                              <div className="flex justify_content_between mt-10">
                                <p>
                                  Child Cost ({`>= 6 yrs`}){" "}
                                  <small>
                                    ̀ (
                                    {calculationsOfPackages?.childCostWithBed /
                                      over6AgeChildren?.length}{" "}
                                    X {over6AgeChildren?.length})
                                  </small>
                                </p>
                                <span
                                  className={`room_text-right ${
                                    Number(
                                      calculationsOfPackages?.childCostWithBed
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                >
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.childCostWithBed
                                  )}
                                </span>
                              </div>
                            ) : null}

                            {calculationsOfPackages?.transportationCost ? (
                              <div className="flex justify_content_between mt-10">
                                <p>
                                  Transportation Cost{" "}
                                  <span className="customizedSinglePackageInfoIcon">
                                    <div className="customizedSinglePackageInfoIconChild">
                                      <div className="flex justify_content_between">
                                        <div>
                                          New Vehicle Price{" "}
                                          {vehicleDetails &&
                                            vehicleDetails?.length > 0 && (
                                              <small>
                                                ({vehicleDetails[0]?.Vehicle})
                                              </small>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </p>
                                <span className="room_text-right ">
                                  {customizableRatesLoader === true ? (
                                    <div
                                      style={{
                                        width: "100px",
                                        filter: "blur(3px)",
                                      }}
                                    >
                                      loader
                                    </div>
                                  ) : (
                                    <>
                                      {" "}
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.transportationCost
                                      )}
                                    </>
                                  )}
                                </span>
                              </div>
                            ) : null}

                            {calculationsOfPackages?.totalActivityCost ? (
                              <div className="flex justify_content_between mt-10">
                                <p>Activity Cost</p>
                                <span className="room_text-right ">
                                  {customizableRatesLoader === true ? (
                                    <div
                                      style={{
                                        width: "100px",
                                        filter: "blur(3px)",
                                      }}
                                    >
                                      loader
                                    </div>
                                  ) : (
                                    <>
                                      {" "}
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.totalActivityCost
                                      )}
                                    </>
                                  )}
                                </span>
                              </div>
                            ) : null}

                            <div className="flex justify_content_between mt-10">
                              <h6>Total Package Cost</h6>
                              <b>
                                {" "}
                                <span className="">
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.basePrice
                                  )}
                                </span>
                              </b>
                            </div>

                            {(selectedAutomaticDiscount?.length > 0 ||
                              selectedDiscount?.length > 0) && (
                              <div className="mt-10">
                                <p>
                                  <b>
                                    Package Discount
                                    {selectedAutomaticDiscount?.length > 1
                                      ? "s"
                                      : ""}
                                  </b>
                                </p>
                                {selectedAutomaticDiscount?.map(
                                  (discount, index) => (
                                    <div
                                      className="flex justify_content_between mt-2"
                                      key={discount.id}
                                    >
                                      <span className="discount-name">
                                        {discount.promotionName}
                                      </span>
                                      <span className="room_text-right green">
                                        {discount.promotionMode === "percentage"
                                          ? `${+discount.promotionAmount}%`
                                          : `${formatIndianCurrency(
                                              discount.promotionAmount
                                            )}`}
                                      </span>
                                    </div>
                                  )
                                )}

                                {selectedDiscount &&
                                  selectedDiscount?.length > 0 &&
                                  selectedDiscount?.map((discount, index) => (
                                    <div
                                      className="flex justify_content_between mt-2"
                                      key={discount.id}
                                    >
                                      <span className="discount-name">
                                        {discount.promotionName}
                                      </span>
                                      <span className="room_text-right green">
                                        {discount.promotionMode === "percentage"
                                          ? `${+discount.promotionAmount}%`
                                          : `${formatIndianCurrency(
                                              discount.promotionAmount
                                            )}`}
                                      </span>
                                    </div>
                                  ))}
                              </div>
                            )}

                            {calculationsOfPackages?.discount > 0 && (
                              <div className="flex justify_content_between mt-10 border-bottom-one ">
                                <p>Package Cost (After Disc.)</p>
                                <span
                                  className={`room_text-right ${
                                    Number(
                                      calculationsOfPackages?.totalAmount
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                >
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.priceAfterDiscount
                                  )}
                                </span>
                              </div>
                            )}

                            {commission &&
                              Object.keys(commission)?.length > 0 && (
                                <>
                                  <div className="flex justify_content_between mt-10">
                                    <p>
                                      Commission{" "}
                                      <small>
                                        ({" "}
                                        {commission.commissionType ===
                                        "fixed" ? (
                                          <span className="room_text-right">
                                            {formatIndianCurrency(
                                              commission?.commissionAmount
                                            )}
                                          </span>
                                        ) : (
                                          <span className="room_text-right">
                                            {commission?.commissionAmount}%
                                          </span>
                                        )}
                                        )
                                      </small>
                                    </p>

                                    {formatIndianCurrency(
                                      calculationsOfPackages?.calculatedCommissionAmount
                                    )}
                                  </div>
                                </>
                              )}

                            {selectedAddOns && selectedAddOns?.length > 0 && (
                              <div className="flex justify_content_between mt-10">
                                <p>Addons Price</p>
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "end",
                                  }}
                                >
                                  {commission &&
                                    Object.keys(commission)?.length > 0 && (
                                      <small
                                        style={{
                                          color: "red",
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        {formatIndianCurrency(
                                          totalAddonsCostWithoutCommission
                                        )}
                                      </small>
                                    )}
                                  <b>{formatIndianCurrency(totalAddonsCost)}</b>
                                </span>
                              </div>
                            )}

                            <div className="flex justify_content_between mt-10">
                              <p>Subtotal </p>

                              {formatIndianCurrency(
                                calculationsOfPackages?.subtotal
                              )}
                            </div>

                            <div className="flex justify_content_between mt-10 border-bottom-one p_b_10">
                              <p>GST(5%) </p>
                              <span className="room_text-right">
                                {formatIndianCurrency(
                                  calculationsOfPackages?.taxAmount
                                )}
                              </span>
                            </div>
                            <div className="flex justify_content_between mt-10">
                              <h6>Grand Total</h6>
                              <h6>
                                <span
                                  className={` ${
                                    Number(
                                      calculationsOfPackages?.totalAmount
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "end",
                                  }}
                                >
                                  {commission &&
                                    Object.keys(commission)?.length > 0 &&
                                    calculationsOfPackages?.totalAgentSavings && (
                                      <small
                                        style={{
                                          color: "red",
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        {formatIndianCurrency(
                                          Number(
                                            calculationsOfPackages?.totalAgentSavings
                                          ) +
                                            Number(
                                              calculationsOfPackages?.totalAmount
                                            )
                                        )}
                                      </small>
                                    )}
                                  <b>
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.totalAmount
                                    )}
                                  </b>
                                </span>
                              </h6>
                            </div>
                            {payNow !== null &&
                              !isNaN(payNow) &&
                              payNow !== 0 &&
                              selectedPercent !== 100 && (
                                <div
                                  className="flex justify_content_between mt-10"
                                  style={{
                                    borderTop: "1px solid #cccccc7c",
                                    paddingTop: "10px",
                                  }}
                                >
                                  <h6>Total Amount to be paid</h6>
                                  <h6>{formatIndianCurrency(payNow)}</h6>
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    </div>
                  </aside>

                  {mobilePriceBreakup && (
                    <>
                      <div
                        className={`${styles.mobilePriceBreakup} ${
                          isItineraryDetailsVisible ? styles.open : styles.close
                        } ${
                          priceBreakupPopup ? styles.open : styles.close
                        } flex justify_content_between total_amount align_items_center`}
                      >
                        <div>
                          <h6 className="font_12">Total Amt. </h6>
                          <h6>
                            <span
                              className={` ${
                                Number(calculationsOfPackages?.totalAmount) <=
                                  0 && "filterBlur3"
                              }`}
                            >
                              {formatIndianCurrency(
                                payNow
                                  ? payNow
                                  : calculationsOfPackages?.totalAmount
                              )}
                            </span>
                          </h6>{" "}
                        </div>
                        <button
                          // onClick={() => setPriceBreakupPopup(true)}
                          onClick={bookPackageHandle}
                          className={styles.book_now_mobile_bottom}
                          disabled={paymentGatewayLoader}
                        >
                          Proceed To Payment
                        </button>
                      </div>
                      {priceBreakupPopup && (
                        <div className="bg_back_drop_overlay">
                          <div
                            className="common_background common_background_parent_sticky"
                            id="PriceBreak"
                          >
                            {" "}
                            <div className="flex justify_content_end p_b_10 ">
                              <svg
                                onClick={() => setPriceBreakupPopup(false)}
                                width="14"
                                height="13"
                                viewBox="0 0 14 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 12.5L13 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                                <path
                                  d="M13 12.5L1 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                              </svg>
                            </div>
                            <div>
                              <h4
                                style={{
                                  fontSize: "14px",
                                  padding: "10px 0px",
                                }}
                              >
                                Fare Summary
                              </h4>

                              <div className="flex justify_content_between mt-10">
                                <p>
                                  Adult Cost
                                  <small>
                                    {" "}
                                    (
                                    {calculationsOfPackages?.onlyAdultCost /
                                      calculationsOfPackages?.adultNumber}{" "}
                                    X {calculationsOfPackages?.adultNumber})
                                  </small>
                                </p>
                                <span
                                  className={`room_text-right ${
                                    Number(
                                      calculationsOfPackages?.onlyAdultCost
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                >
                                  {formatIndianCurrency(
                                    Number(
                                      calculationsOfPackages?.onlyAdultCost
                                    )
                                  )}
                                </span>
                              </div>

                              {calculationsOfPackages?.extraAdultNumber > 0 && (
                                <div className="flex justify_content_between mt-10">
                                  <p>
                                    Extra Adult Cost{" "}
                                    <small>
                                      {" "}
                                      (
                                      {/* {commission && Object.keys(commission).length > 0 && (
                                                <span style={{ color: 'red', textDecoration: 'line-through' }}>
                                                  {(calculationsOfPackages?.ExtraAdultCost /
                                                    calculationsOfPackages?.extraAdultNumber) +
                                                    calculationsOfPackages?.extraAdultSavings}
                                                  {" "}
                                                </span>
                                              )} */}
                                      {calculationsOfPackages?.ExtraAdultCost /
                                        calculationsOfPackages?.extraAdultNumber}{" "}
                                      X{" "}
                                      {calculationsOfPackages?.extraAdultNumber}
                                      )
                                    </small>
                                  </p>
                                  <span
                                    className={`room_text-right ${
                                      Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                  >
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.ExtraAdultCost
                                    )}
                                    {/* {formatIndianCurrency(Number(calculationsOfPackages?.ExtraAdultCost) + Number(calculationsOfPackages?.basePrice))} */}
                                  </span>
                                </div>
                              )}

                              {under6AgeChildren?.length > 0 &&
                              calculationsOfPackages?.childNumber > 0 &&
                              calculationsOfPackages?.childCostWithOutBed ? (
                                <div className="flex justify_content_between mt-10">
                                  <p>
                                    Child Cost ({`< 6 yrs`}){" "}
                                    <small>
                                      ̀ (
                                      {Math.round(
                                        calculationsOfPackages?.childCostWithOutBed /
                                          under6AgeChildren?.length
                                      )}
                                      X {under6AgeChildren?.length})
                                    </small>
                                  </p>
                                  <span
                                    className={`room_text-right ${
                                      Number(
                                        calculationsOfPackages?.childCostWithOutBed
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                  >
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.childCostWithOutBed
                                    )}
                                  </span>
                                </div>
                              ) : null}

                              {over6AgeChildren?.length > 0 &&
                              calculationsOfPackages?.childNumber > 0 &&
                              calculationsOfPackages?.childCostWithBed ? (
                                <div className="flex justify_content_between mt-10">
                                  <p>
                                    Child Cost ({`>= 6 yrs`}){" "}
                                    <small>
                                      ̀ (
                                      {/* {commission && Object.keys(commission).length > 0 && (
                                                  <span style={{ color: 'red', textDecoration: 'line-through' }}>
                                                    {(calculationsOfPackages?.childCostWithBed /
                                                      under6AgeChildren.length) +
                                                      calculationsOfPackages?.childSavingsWithBed}
                                                    {" "}
                                                  </span>
                                                )} */}
                                      {calculationsOfPackages?.childCostWithBed /
                                        over6AgeChildren?.length}{" "}
                                      X {over6AgeChildren?.length})
                                    </small>
                                  </p>
                                  <span
                                    className={`room_text-right ${
                                      Number(
                                        calculationsOfPackages?.childCostWithBed
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                  >
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.childCostWithBed
                                    )}
                                  </span>
                                </div>
                              ) : null}

                              <div className="flex justify_content_between mt-10">
                                <p>Package Cost</p>
                                <span className="room_text-right alert_text">
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.basePrice
                                  )}
                                </span>
                              </div>

                              {(selectedAutomaticDiscount?.length > 0 ||
                                selectedDiscount?.length > 0) && (
                                <div className="mt-10">
                                  <p>
                                    <b>
                                      Package Discount
                                      {selectedAutomaticDiscount?.length > 1
                                        ? "s"
                                        : ""}
                                    </b>
                                  </p>
                                  {selectedAutomaticDiscount?.map(
                                    (discount, index) => (
                                      <div
                                        className="flex justify_content_between mt-2"
                                        key={discount.id}
                                      >
                                        <span className="discount-name">
                                          {discount.promotionName}
                                        </span>
                                        <span className="room_text-right green">
                                          {discount.promotionMode ===
                                          "percentage"
                                            ? `${+discount.promotionAmount}%`
                                            : `${formatIndianCurrency(
                                                discount.promotionAmount
                                              )}`}
                                        </span>
                                      </div>
                                    )
                                  )}

                                  {selectedDiscount &&
                                    selectedDiscount?.length > 0 &&
                                    selectedDiscount?.map((discount, index) => (
                                      <div
                                        className="flex justify_content_between mt-2"
                                        key={discount.id}
                                      >
                                        <span className="discount-name">
                                          {discount.promotionName}
                                        </span>
                                        <span className="room_text-right green">
                                          {discount.promotionMode ===
                                          "percentage"
                                            ? `${+discount.promotionAmount}%`
                                            : `${formatIndianCurrency(
                                                discount.promotionAmount
                                              )}`}
                                        </span>
                                      </div>
                                    ))}
                                </div>
                              )}

                              {calculationsOfPackages?.discount > 0 && (
                                <div className="flex justify_content_between mt-10 border-bottom-one ">
                                  <p>Package Cost (After Disc.)</p>
                                  <span
                                    className={`room_text-right ${
                                      Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                  >
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.priceAfterDiscount
                                    )}
                                  </span>
                                </div>
                              )}

                              {commission &&
                                Object.keys(commission).length > 0 && (
                                  <>
                                    <div className="flex justify_content_between mt-10">
                                      <p>
                                        Commission{" "}
                                        <small>
                                          ({" "}
                                          {commission.commissionType ===
                                          "fixed" ? (
                                            <span className="room_text-right">
                                              {formatIndianCurrency(
                                                commission?.commissionAmount
                                              )}
                                            </span>
                                          ) : (
                                            <span className="room_text-right">
                                              {commission?.commissionAmount}%
                                            </span>
                                          )}
                                          )
                                        </small>
                                      </p>

                                      {formatIndianCurrency(
                                        calculationsOfPackages?.calculatedCommissionAmount
                                      )}
                                    </div>
                                  </>
                                )}

                              {selectedAddOns && selectedAddOns?.length > 0 && (
                                <div className="flex justify_content_between mt-10">
                                  <p>Addons Price</p>
                                  <span
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "end",
                                    }}
                                  >
                                    {commission &&
                                      Object.keys(commission)?.length > 0 && (
                                        <small
                                          style={{
                                            color: "red",
                                            textDecoration: "line-through",
                                          }}
                                        >
                                          {formatIndianCurrency(
                                            totalAddonsCostWithoutCommission
                                          )}
                                        </small>
                                      )}
                                    <b>
                                      {formatIndianCurrency(totalAddonsCost)}
                                    </b>
                                  </span>
                                </div>
                              )}

                              <div className="flex justify_content_between mt-10">
                                <p>Subtotal </p>

                                {formatIndianCurrency(
                                  calculationsOfPackages?.subtotal
                                )}
                              </div>

                              <div className="flex justify_content_between mt-10 border-bottom-one p_b_10">
                                <p>GST(5%) </p>
                                <span className="room_text-right">
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.taxAmount
                                  )}
                                </span>
                              </div>

                              {commission &&
                                Object.keys(commission)?.length > 0 &&
                                calculationsOfPackages?.totalAgentSavings && (
                                  <>
                                    <div className="flex justify_content_between mt-10">
                                      <p>Your Savings</p>
                                      <span className="room_text-right">
                                        {formatIndianCurrency(
                                          calculationsOfPackages?.totalAgentSavings
                                        )}
                                      </span>
                                    </div>
                                  </>
                                )}

                              <div className="flex justify_content_between mt-10">
                                <h6>
                                  <b>Total Amount To Be Paid</b>
                                </h6>
                                <h6>
                                  <span
                                    className={` ${
                                      Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "end",
                                    }}
                                  >
                                    {commission &&
                                      Object.keys(commission)?.length > 0 &&
                                      calculationsOfPackages?.totalAgentSavings && (
                                        <small
                                          style={{
                                            color: "red",
                                            textDecoration: "line-through",
                                          }}
                                        >
                                          {formatIndianCurrency(
                                            Number(
                                              calculationsOfPackages?.totalAgentSavings
                                            ) +
                                              Number(
                                                calculationsOfPackages?.totalAmount
                                              )
                                          )}
                                        </small>
                                      )}
                                    <b>
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.totalAmount
                                      )}
                                    </b>
                                  </span>
                                </h6>
                              </div>

                              <div
                                onClick={bookPackageHandle}
                                className={styles.pay_now_btn}
                              >
                                Pay Now
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {isItineraryDetailsVisible && (
        // <ItnerarySideBar
        //   // singleBookingData={singleBookingData}
        //   onClose={handleCloseSlider}
        //   setIsSliderVisible={setIsSliderVisible}
        //   singlePackageData={singlePackageData}
        //   isItineraryDetailsVisible={isItineraryDetailsVisible}
        //   setIsItineraryDetailsVisible={setIsItineraryDetailsVisible}
        //   allPackageHotels={allPackageHotels}
        //   selectedCategory={selectedCategory}
        // />

        <NewItnerarySidebar
          // singleBookingData={singleBookingData}
          onClose={handleCloseSlider}
          setIsSliderVisible={setIsSliderVisible}
          singlePackageData={singlePackageData}
          isItineraryDetailsVisible={isItineraryDetailsVisible}
          setIsItineraryDetailsVisible={setIsItineraryDetailsVisible}
          allPackageHotels={allPackageHotels}
          selectedCategory={selectedCategory}
        />
      )}

      <NTTData
        mainData={mainData}
        selectedPaymentGateway={selectedPaymentGateway}
        setPaymentGatewayLoader={setPaymentGatewayLoader}
      />

      <section className={styles.sm_footer}>{/* <CheckoutFooter /> */}</section>
    </>
  );
};

export default PackagesCheckoutPage;
